import React from 'react';
const values = [{
  title: 'Odbornost',
  description: 'Náš tým je složen ze zkušených pracovníků, kteří mají dlouholeté zkušenosti v oboru. Každý náš pracovník prochází pravidelným školením dodavatelů, výrobců a institucí a má potřebné certifikáty a atesty. Provádíme odborně odbornou práci a víme jak na to.'
}, {
  title: 'Kvalita produktů',
  description: 'Zakládáme si na používání kvalitních produktů. Od kabeláže, přes pomocný materiál, až po koncové prvky. V maximální možné míře používáme originální prvky a sestavy dle doporučení výrobců, řešení v souladu s nejaktuálnějšími trendy a potřebami projektu. Kvalitní řešení znamená především jistotu pro zákazníka. Nepodbízíme se nízkou cenu za cenu nízké kvality.'
}, {
  title: 'Kvalita práce',
  description: 'Naši pracovníci pracují čistě, ohleduplně k prostředí, v jakém pracují, a maximálně využívají všech prostředků pro dosažení kvalitního výsledku. Všechny provedené práce jsou uzavírány pečlivou kontrolou. Všechny práce jsou evidovány pro pozdější kontrolu ze strany zákazníka.'
}, {
  title: 'Dokumentace',
  description: 'Všechny realizace jsou dodány s dokumentací provedení – doklady ke komponentům, schémata zapojení, výkresy rozvodů apod. Víme, co děláme a umíme to doložit.'
}, {
  title: 'Fair play',
  description: 'Při naší práci je důležitá empatie. Nenavyšujeme dodatečné rozpočty, pokud zákazník nerozšíří objednávku. Snažíme se maximálně vyhovět potřebám zákazníka, a při realizaci máme na srdci nejen kvalitní zpracování díla, ale i jeho zájmy.'
}, {
  title: 'Osobní přístup',
  description: 'Každý projekt je nastaven na míru zákazníkovi. Pečlivě volíme to správné řešení s ohledem na jeho potřeby a možnosti.'
}, {
  title: 'Servis',
  description: 'Každý umí dodat, ne každý se umí postarat. Je pro nás stejně důležité dodat kvalitní dílo, jako zajistit i následnou péči o zákazníka. Jsme pro něj oporou vždy.'
}, {
  title: 'Dostupnost',
  description: 'Jsme maximálně flexibilní. Není důležité, jak je váš dodavatel daleko, ale jak rychle je schopen reagovat.'
}];
export function ValuesSection() {
  return <section className="w-full bg-[#f5f5f5] py-16 border-t border-gray-200" data-id="element-327">
      <div className="max-w-6xl mx-auto px-6" data-id="element-328">
        <div className="grid grid-cols-1 md:grid-cols-[220px_1fr] gap-16" data-id="element-329">
          {/* Left Column - Heading */}
          <div data-id="element-330">
            <h2 className="text-2xl font-normal text-[#707070] tracking-wide" data-id="element-331">
              NA ČEM NÁM ZÁLEŽÍ
            </h2>
          </div>

          {/* Right Column - Values List */}
          <div className="space-y-6" data-id="element-332">
            {values.map((value, index) => <div key={value.title} className={`pb-6 ${index !== values.length - 1 ? 'border-b border-gray-300' : ''}`} data-id="element-333">
                <h3 className="text-base font-medium text-[#505050] mb-2" data-id="element-334">
                  {value.title}
                </h3>
                <p className="text-[#707070] leading-relaxed text-sm" data-id="element-335">
                  {value.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}